/**
 * Adapter between `AssetItemList`, which reports a new order as plain ids, and
 * the `handle*TabOrderUpdate` handlers the asset tabs already had, which speak
 * the `[{ value: '<prefix>_tab_<id>' }]` shape `gd-tabs` used to emit.
 *
 * Ids come back from the API as whatever the stored JSON held, so everything
 * here compares them as strings: an item created in this session has a numeric
 * id from `generateNumberMixin`, while the same item reloaded from the server
 * may well arrive as `"1720…"`. The old `parseInt` + `indexOf` comparison
 * silently returned -1 for every string id and left the order untouched.
 */

export const tabValue = (prefix, id) => `${prefix}_tab_${id}`;

export const toTabOrder = (prefix, ids) => ids.map(id => ({ value: tabValue(prefix, id) }));

export const idFromTabValue = (prefix, value) => String(value).replace(`${prefix}_tab_`, '');

/**
 * Sort `items` in place into the order described by `updatedTabs`. Items the
 * new order does not mention keep their relative position after the ones it
 * does, rather than jumping to the front the way a -1 index would put them.
 */
export function sortByTabOrder(items, prefix, updatedTabs) {
  const order = updatedTabs.map(tab => idFromTabValue(prefix, tab.value));
  const positionOf = (item) => {
    const index = order.indexOf(String(item.id));
    return index === -1 ? order.length : index;
  };

  items.sort((a, b) => positionOf(a) - positionOf(b));

  return items;
}
